import { __cBannerService } from '@/services/client/__c.banner.service'
import { useQuery } from '@tanstack/react-query'

export const useBannerQuery = () => {
  return useQuery({
    queryKey: ['banner'],
    queryFn: async () => {
      return await __cBannerService.getBannerSettings()
    },
  })
}
